<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <ListPageShell>
    <template #header>
      <div class="list-page-panel is-header-minimal">
        <div class="list-page-heading">
          <div class="list-page-heading-main">
            <h1 class="list-page-title">引入人管理</h1>
            <p class="list-page-description">维护引入人资料、类型和启用状态</p>
          </div>
        </div>
      </div>

    <!-- 搜索筛选区 -->
    </template>
    <div class="list-page-table-panel mb-6">
      <PageFilterBar
        body-class="p-6 border-b border-slate-200"
        :show-refresh="true"
        :refresh-loading="loading"
        @refresh="fetchData"
      >
          <div class="relative flex-1 min-w-[200px] max-w-xs">
            <label class="block text-sm text-slate-600 mb-1">引入人姓名</label>
            <input
              v-model="queryParams.name"
              type="text"
              placeholder="搜索引入人姓名"
              class="form-input w-full"
            >
          </div>
          <div class="relative flex-1 min-w-[200px] max-w-xs">
            <label class="block text-sm text-slate-600 mb-1">联系电话</label>
            <input
              v-model="queryParams.phone"
              type="text"
              placeholder="搜索联系电话"
              class="form-input w-full"
            >
          </div>
          <div class="relative min-w-[150px]">
            <label class="block text-sm text-slate-600 mb-1">引入类型</label>
            <select
              v-model="queryParams.referrerType"
              class="form-select-native w-full"
            >
              <option value="">全部类型</option>
              <option value="0">渠道</option>
              <option value="1">客户转介绍</option>
              <option value="2">政府</option>
              <option value="3">其他</option>
            </select>
          </div>
          <div class="relative min-w-[150px]">
            <label class="block text-sm text-slate-600 mb-1">状态</label>
            <select
              v-model="queryParams.status"
              class="form-select-native w-full"
            >
              <option value="">全部状态</option>
              <option :value="1">启用</option>
              <option :value="0">禁用</option>
            </select>
          </div>

        <template #searchActions>
          <button
            @click="handleSearch"
            class="btn-primary"
          >
            搜索
          </button>
          <button
            @click="handleReset"
            class="btn-secondary"
          >
            重置
          </button>
        </template>
      </PageFilterBar>

      <!-- 操作栏 -->
      <div class="px-6 py-4 flex items-center justify-between border-b border-slate-200">
        <div class="text-sm text-slate-600">
          共 <span class="font-medium text-slate-900">{{ total }}</span> 条引入人
        </div>
        <button
          v-permission="'referrer:add'"
          @click="handleAdd"
          class="btn-primary"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          新增引入人
        </button>
      </div>

      <!-- 数据表格 -->
      <div class="data-table-shell">
        <div class="data-table-scroll">
          <table class="data-table text-sm">
            <thead class="data-table-head">
              <tr>
                <th class="data-table-th text-left">引入人姓名</th>
                <th class="data-table-th text-left">联系电话</th>
                <th class="data-table-th text-left">微信号</th>
                <th class="data-table-th text-left">引入类型</th>
                <th class="data-table-th text-right">累计客户数</th>
                <th class="data-table-th text-left">状态</th>
                <th class="data-table-th text-left">创建时间</th>
                <th class="data-table-th text-left">备注</th>
                <th class="data-table-th text-center w-32">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="9" class="data-table-td is-center">
                  <div class="flex flex-col items-center justify-center">
                    <div class="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mb-3"></div>
                    <span class="text-slate-500">加载中...</span>
                  </div>
                </td>
              </tr>
              <tr v-else-if="list.length === 0">
                <td colspan="9" class="data-table-empty">
                  <div class="flex flex-col items-center justify-center">
                    <svg class="w-12 h-12 text-slate-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                    </svg>
                    <span>暂无数据</span>
                  </div>
                </td>
              </tr>
              <tr
                v-for="item in list"
                :key="item.id"
                class="data-table-row"
              >
                <td class="data-table-td">
                  <div class="font-medium text-slate-900">{{ item.name }}</div>
                </td>
                <td class="data-table-td text-slate-600">{{ item.phone }}</td>
                <td class="data-table-td text-slate-600">{{ item.wechat || '-' }}</td>
                <td class="data-table-td">
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                    :class="{
                      'bg-blue-100 text-blue-800': item.referrerType === '0',
                      'bg-green-100 text-green-800': item.referrerType === '1',
                      'bg-purple-100 text-purple-800': item.referrerType === '2',
                      'bg-gray-100 text-gray-800': item.referrerType === '3'
                    }"
                  >
                    {{ item.referrerTypeName || getReferrerTypeName(item.referrerType) }}
                  </span>
                </td>
                <td class="data-table-td is-right text-slate-600">{{ item.totalCustomerCount || 0 }}</td>
                <td class="data-table-td">
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium cursor-pointer"
                    :class="{
                      'bg-green-100 text-green-800': item.status === 1,
                      'bg-red-100 text-red-800': item.status === 0
                    }"
                    @click="handleToggleStatus(item)"
                  >
                    {{ item.statusName || (item.status === 1 ? '启用' : '禁用') }}
                  </span>
                </td>
                <td class="data-table-td text-slate-600">{{ formatTime(item.createTime) }}</td>
                <td class="data-table-td text-slate-600 max-w-[200px] truncate" :title="item.remark">
                  {{ item.remark || '-' }}
                </td>
                <td class="data-table-td is-center">
                  <div class="flex items-center justify-center gap-1">
                    <button
                      @click="handleViewDetail(item)"
                      class="table-action-button is-primary"
                      title="详情"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                      </svg>
                    </button>
                    <button
                      v-permission="'referrer:edit'"
                      @click="handleEdit(item)"
                      class="table-action-button is-primary"
                      title="编辑"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                      </svg>
                    </button>
                    <button
                      v-permission="'referrer:delete'"
                      @click="handleDelete(item)"
                      class="table-action-button is-danger"
                      title="删除"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                    <button
                      v-permission="'referrer:bind-app-user'"
                      @click="handleBindAppUserOpen(item)"
                      class="table-action-button is-primary"
                      title="绑定APP用户"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 分页 -->
      <AppPagination
        class="pagination-bridge"
        v-if="list.length > 0"
        :pagination="pagination"
        :page-sizes="[10, 20, 50]"
        total-label="共 "
        total-suffix=" 条引入人"
        @page-change="handlePageChange"
        @size-change="handlePageSizeChange"
      />
    </div>

    <!-- 新增/编辑弹窗 -->
    <ReferrerFormModal
      v-model:visible="formModalVisible"
      :referrer-data="currentReferrer"
      @success="handleFormSuccess"
    />

    <!-- 详情弹窗 -->
    <ReferrerDetailModal
      v-model:visible="detailModalVisible"
      :referrer-id="currentReferrerId"
      :referrer-info="currentReferrer"
    />

    <!-- 绑定APP用户弹窗 -->
    <el-dialog
      v-model="bindDialogVisible"
      title="绑定APP用户"
      width="440px"
      :close-on-click-modal="false"
    >
      <div v-if="bindLoading" class="flex justify-center py-8">
        <div class="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
      <template v-else>
        <el-form
          ref="bindFormRef"
          :model="bindForm"
          :rules="bindFormRules"
          label-width="100px"
        >
          <el-form-item label="引入人">
            <span class="text-slate-900">{{ currentReferrer?.name }}</span>
          </el-form-item>
          <el-form-item v-if="boundAppUser" label="已绑定用户">
            <div class="flex items-center gap-3">
              <img
                v-if="boundAppUser.avatar"
                :src="boundAppUser.avatar"
                class="w-10 h-10 rounded-full object-cover"
              >
              <div v-else class="w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center">
                <svg class="w-5 h-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                </svg>
              </div>
              <div>
                <div class="text-slate-900 font-medium">{{ boundAppUser.nickname || '未设置昵称' }}</div>
                <div class="text-slate-500 text-sm">{{ boundAppUser.phone }}</div>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-if="!boundAppUser" label="APP用户手机号" prop="phone">
            <el-input
              v-model="bindForm.phone"
              placeholder="请输入APP用户手机号"
              maxlength="11"
              show-word-limit
            />
          </el-form-item>
          <el-form-item v-if="boundAppUser" label="操作">
            <button
              @click="handleUnbindAppUser"
              class="btn-danger-secondary"
              type="button"
            >
              解除绑定
            </button>
          </el-form-item>
        </el-form>
      </template>
      <template #footer v-if="!bindLoading">
        <div class="flex justify-end gap-3">
          <button
            @click="bindDialogVisible = false"
            class="btn-secondary"
          >
            取消
          </button>
          <button
            v-if="!boundAppUser"
            @click="handleBindAppUser"
            class="btn-primary"
            :disabled="bindSubmitLoading"
          >
            {{ bindSubmitLoading ? '绑定中...' : '确定绑定' }}
          </button>
        </div>
      </template>
    </el-dialog>
  </ListPageShell>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getReferrerPage, updateReferrerStatus, deleteReferrer, bindAppUser, getReferrerAppUser, unbindAppUser } from '@/api/referrer'
import AppPagination from '@/components/AppPagination.vue'
import ListPageShell from '@/components/ListPageShell.vue'
import PageFilterBar from '@/components/PageFilterBar.vue'
import ReferrerFormModal from '@/components/ReferrerFormModal.vue'
import ReferrerDetailModal from './components/ReferrerDetailModal.vue'

// 引入人类型映射
const referrerTypeMap = {
  '0': '渠道',
  '1': '客户转介绍',
  '2': '政府',
  '3': '其他'
}

const getReferrerTypeName = (type) => {
  return referrerTypeMap[type] || '-'
}

// 格式化时间
const formatTime = (time) => {
  if (!time) return '-'
  return new Date(time).toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

// 数据列表
const list = ref([])
const loading = ref(false)
const total = ref(0)

// 查询参数
const queryParams = reactive({
  name: '',
  phone: '',
  referrerType: '',
  status: ''
})

// 分页
const pagination = reactive({
  current: 1,
  size: 10,
  pages: 1
})

// 表单弹窗
const formModalVisible = ref(false)
const currentReferrer = ref(null)

// 详情弹窗
const detailModalVisible = ref(false)
const currentReferrerId = ref(null)

// 绑定APP用户弹窗
const bindDialogVisible = ref(false)
const bindLoading = ref(false)
const bindSubmitLoading = ref(false)
const bindFormRef = ref(null)
const bindForm = reactive({
  referrerId: null,
  phone: ''
})
const bindFormRules = {
  phone: [
    { required: true, message: '请输入APP用户手机号', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
  ]
}
const boundAppUser = ref(null)

// 计算可见页码

// 加载数据
const fetchData = async () => {
  loading.value = true
  try {
    const params = {
      page: pagination.current,
      size: pagination.size,
      ...Object.fromEntries(
        Object.entries(queryParams).filter(([, v]) => v !== '' && v !== null && v !== undefined)
      )
    }
    const data = await getReferrerPage(params)
    list.value = data.records || []
    total.value = data.total || 0
    pagination.pages = data.pages || 1
  } catch (error) {
    console.error('获取引入人列表失败:', error)
    ElMessage.error(error.message || '获取引入人列表失败')
  } finally {
    loading.value = false
  }
}

// 搜索
const handleSearch = () => {
  pagination.current = 1
  fetchData()
}

// 重置
const handleReset = () => {
  queryParams.name = ''
  queryParams.phone = ''
  queryParams.referrerType = ''
  queryParams.status = ''
  pagination.current = 1
  fetchData()
}

// 分页
const handlePageChange = (page) => {
  if (page < 1 || page > pagination.pages) return
  pagination.current = page
  fetchData()
}

const handlePageSizeChange = (size) => {
  pagination.size = size
  pagination.current = 1
  fetchData()
}

// 新增
const handleAdd = () => {
  currentReferrer.value = null
  formModalVisible.value = true
}

// 编辑
const handleEdit = (item) => {
  currentReferrer.value = { ...item }
  formModalVisible.value = true
}

// 查看详情
const handleViewDetail = (item) => {
  currentReferrer.value = { ...item }
  currentReferrerId.value = item.id
  detailModalVisible.value = true
}

// 删除
const handleDelete = async (item) => {
  try {
    await ElMessageBox.confirm(
      `确定要删除引入人「${item.name}」吗？`,
      '删除确认',
      {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }
    )
    await deleteReferrer(item.id)
    ElMessage.success('删除成功')
    fetchData()
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除引入人失败:', error)
      ElMessage.error(error.message || '删除引入人失败')
    }
  }
}

// 切换状态
const handleToggleStatus = async (item) => {
  const newStatus = item.status === 1 ? 0 : 1
  const statusText = newStatus === 1 ? '启用' : '禁用'

  try {
    await ElMessageBox.confirm(
      `确定要${statusText}引入人「${item.name}」吗？`,
      '状态切换',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    )
    await updateReferrerStatus(item.id, newStatus)
    ElMessage.success(`${statusText}成功`)
    fetchData()
  } catch (error) {
    if (error !== 'cancel') {
      console.error('切换状态失败:', error)
      ElMessage.error(error.message || '切换状态失败')
    }
  }
}

// 表单提交成功
const handleFormSuccess = () => {
  fetchData()
}

// 绑定APP用户
const handleBindAppUserOpen = async (item) => {
  currentReferrer.value = { ...item }
  bindForm.referrerId = item.id
  bindForm.phone = ''
  boundAppUser.value = null
  bindDialogVisible.value = true
  bindLoading.value = true
  try {
    const data = await getReferrerAppUser(item.id)
    boundAppUser.value = data || null
  } catch (error) {
    boundAppUser.value = null
  } finally {
    bindLoading.value = false
  }
}

const handleBindAppUser = async () => {
  const valid = await bindFormRef.value.validate().catch(() => false)
  if (!valid) return

  bindSubmitLoading.value = true
  try {
    await bindAppUser(currentReferrer.value.id, {
      referrerId: bindForm.referrerId,
      phone: bindForm.phone
    })
    ElMessage.success('绑定成功')
    bindDialogVisible.value = false
    fetchData()
  } catch (error) {
    console.error('绑定APP用户失败:', error)
    ElMessage.error(error.message || '绑定APP用户失败')
  } finally {
    bindSubmitLoading.value = false
  }
}

const handleUnbindAppUser = async () => {
  try {
    await ElMessageBox.confirm(
      `确定要解除「${currentReferrer.value?.name}」的APP用户绑定吗？`,
      '解除绑定',
      {
        confirmButtonText: '确定解除',
        cancelButtonText: '取消',
        type: 'warning'
      }
    )
    await unbindAppUser(currentReferrer.value.id)
    ElMessage.success('解除绑定成功')
    boundAppUser.value = null
    fetchData()
  } catch (error) {
    if (error !== 'cancel') {
      console.error('解除绑定失败:', error)
      ElMessage.error(error.message || '解除绑定失败')
    }
  }
}

// 初始化
onMounted(() => {
  fetchData()
})
</script>
